import firebase from "firebase/compat/app"
import 'firebase/compat/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyBuuDmKtRQj7JEHL-7VGcT_kygqYUwKF-4",
  authDomain: "ecossories-bd.firebaseapp.com",
  projectId: "ecossories-bd",
  storageBucket: "ecossories-bd.appspot.com",
  messagingSenderId: "354125159427",
  appId: "1:354125159427:web:6f20de6b24aad79a1b4236",
  measurementId: "G-28QFD9044R"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const db=firebase.firestore()
export {db}